<template>
  <div>
    <div class="sensor-list">
      <div
        v-for="i in sensorData"
        :key="i.identifier"
        :style="{color:color[i.status]}"
        class="item"
      >
        <div class="wh-flex-between" @click="handleShowStatistic(i)">
          <svg-icon :icon-class="i.identifier" class="sensor-icon" />
          <span class="name">{{ i.name }} <van-icon name="arrow" /></span>
        </div>
        <div>
          <div class="value-wrapper wh-flex-between">
            <span><span class="val">{{ i.value }}</span><span class="unit">{{ i.unit }}</span></span>
            <svg-icon
              v-if="i.status!==undefined"
              icon-class="warning"
              class="warning-icon"
              @click.native="handleShowWarning(i)"
            />
          </div>
          <img src="./images/linear-value.png" alt="" class="linear-value">
          <div class="default-val">
            <span v-if="!(i.max===0&&i.min===0)">安全值{{ i.min + '-' + i.max + i.unit }}</span><span v-else>&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="popup.warning" class="warning-popup">
      <img src="./images/warning-dialog.png" alt="">
      <p>{{ warningContent }}</p>
    </van-popup>
    <sensor-statistic-popup v-model="popup.statistic" :device-data="deviceData" :sensor="sensor" />
  </div>
</template>

<script>
import SensorStatisticPopup from '../sensor-statistic-popup'
import api from '@/api'

export default {
  name: 'Index',
  components: { SensorStatisticPopup },
  props: {
    sensorData: {
      type: Array,
      default() {
        return []
      }
    },
    deviceData: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      color: ['#FF8624', '#FF3B3B'],
      popup: {
        statistic: false,
        warning: false
      },
      sensor: {},
      warningContent: ''
    }
  },
  methods: {
    handleShowStatistic(data) {
      this.sensor = data
      this.popup.statistic = true
    },
    handleShowWarning(data) {
      api.getWarningMsgByIdentifier({
        identifier: data.identifier,
        productKey: this.deviceData.productKey,
        deviceName: this.deviceData.deviceName
      }).then(({ data }) => {
        this.warningContent = data.warningContent
        this.popup.warning = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sensor-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 13px 15px;
  margin-top: 20px;
  > .item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 12px 10px;
    font-size: 12px;
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 12px 1px rgba(205, 205, 205, 0.2);
    color: @primary-color;
  }
  .name {
    font-weight: 500;
    color: #3D3D3D;
  }
  .sensor-icon {
    flex-shrink: 0;
    margin-right: 6px;
    width: 24px;
    height: 24px;
  }
  .linear-value {
    width: 100%;
    height: auto;
  }
  .value-wrapper {
    margin: 12px 0 9px;
    font-weight: bold;
  }
  .val {
    font-size: 24px;
  }
  .unit {
    font-size: 16px;
  }
  .warning-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
  .default-val {
    font-size: 12px;
    font-weight: 500;
    color: #767676;
  }
}
.warning-popup {
  border-radius: 8px;
  width: 80%;
  padding: 10px;
  img {
    display: block;
    margin: 0 auto;
  }
  p {
    text-align: center;
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
